import React, { Component } from 'react'
import { DatePicker, Icon, Spin, Table, Tag, Divider, Modal, Tooltip, Button, message } from 'antd';
import MenuSider from '../../../components/MenuSider'
import ScrollToTop from '../../../components/ScrollToTop'
import { Odata_Url, Constants, Odata_2_Url } from '../../../Constants/Constants'
import axios from 'axios'
import './capa_manager.scss'
import moment from 'moment';
import history from "./history";
import { toUpperKey } from '../../../util/helpper'
import IntlMessages from '../../../util/IntlMessages';


const { MonthPicker } = DatePicker;
const { Column } = Table

const Status = {
    Open: 1,
    "Waiting for approval": 2,
    Approved: 3,
    Rejected: 4,
    Cancelled: 5,
    Completed: 6,
    "Revised due date": 7
}

const GetStatusColor = (status) => {
    return status === Status.Approved ? 'green' :
        [Status.Rejected, Status.Cancelled].indexOf(status) > -1 ? 'red' :
            [Status.Returned].indexOf(status) > -1 || status === 'Revised due date' ? 'yellow' :
                [Status.Completed].indexOf(status) > -1 ? 'blue' :
                    'volcano'
}

export default class CapaManager extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ObtranID: '',
            visible: false,
            tableLoading: false,
            onLoading: false,
            approveLoading: false,
            returnLoading: false,
            rejectLoading: false,
            isButtonLoading: false,
            dataObservation: [],
            dataAction: {}
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let stateEng = JSON.parse(window.localStorage.getItem('state'))
        let isEng = stateEng.setting.locale.locale == 'en'
        if (isEng !== prevState.isEng)
            this.setState({ isEng: isEng })
    }

    componentWillMount() {
        var ObtranID = this.props.location.state === undefined || this.props.location.state.back === undefined ? '' : this.props.location.state.back.ObtranID
        this.setState({ ObtranID: ObtranID })

        let state = JSON.parse(window.localStorage.getItem('state'))
        let isEng = state.setting.locale.locale == 'en'
        this.setState({ isEng: isEng })

        let date = moment()
        let this_month = date._d.getMonth() + 1
        let this_year = date._d.getFullYear()
        let Day = (this_year + "-" + this_month)

        this.getObservation(Day);
    }

    componentDidMount() {
        if (history.location.state && history.location.state.back) {
            let state = { ...history.location.state }
            delete state.back
            history.replace({ ...history.location, state })
        }
    }

    getObservation(Day) {
        this.setState({ tableLoading: true });
        const state = JSON.parse(window.localStorage.getItem('User_Info'))
        const user_name = state.PKUserID

        let month = Day.split('-')[1]
        let year = Day.split('-')[0]

        let url = 'api/ObservationTransaction/SearchObservation'
        let criteria = {
            Month: month,
            Year: year,
            ResponsibleManager: user_name,
            CurrentStatus: 2
        }

        url += '?'
        for (let key in criteria) {
            url += `${encodeURIComponent(key)}=${encodeURIComponent((criteria[key] === undefined || criteria[key] === null ? '' : criteria[key]))}`
            url += '&'
        }
        url = url.slice(0, url.length - 1)

        this.getToken().then(token => {

            let tokenHeader = {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            };

            axios.get(Constants.BASE_URL + url, tokenHeader)
                .then((response) => {
                    const data = [];
                    response.data.forEach(function (element) {
                        data.push(toUpperKey(element));
                    });
                    this.setState({
                        dataObservation: data
                    })
                    this.setState({ tableLoading: false });
                }, (error) => {
                    console.log(error)
                    this.setState({ tableLoading: false });
                })
        });

        
    }

    onChangeMonth = (date, dateString) => {
        this.getObservation(dateString);
    }


    handleClickTakeAction(row) {
        this.setState({ visible: true, dataAction: row });
    }

    handleClickView(row) {
        this.props.history.push({
            pathname: "/capa/" + row.PkObTranID,
            //state: { Obtran: row, parent: '/capa' }
        });
    };

    handleAction(action) {
        this.setState({
            approveLoading: Status.Approved === action,
            returnLoading: Status.Returned === action,
            rejectLoading: Status.Rejected === action,
            isButtonLoading: true
        })

        let data = this.state.dataAction;
        data.Status = action
        var ObtranEn = JSON.stringify(data)

        this.getToken().then(token => {

            let tokenHeader = {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            };

            axios.post(Constants.BASE_URL + "api/ObservationTransaction/UpdateStatus", { Obtran: ObtranEn }, tokenHeader)
                .then((response) => {
                    //Finished the fob
                    this.setState({ visible: false, dataAction: {} });
                    this.setState({
                        approveLoading: false,
                        returnLoading: false,
                        rejectLoading: false,
                        isButtonLoading: false
                    })
                    message.success("Your transaction has been successfully.")
                    return
                },
                    (error) => {
                        console.log(error);
                        message.error("Something went wrong please try again.")
                        this.setState({ visible: false, dataAction: {} });
                        return
                    })
        });

        
        return
    };

    handleCancel = () => {
        this.setState({ visible: false, dataAction: {} });
        return
    };

    disabledDate(current) {
        return current && current > moment().endOf('day');
    }

    getToken() {
        var $getToken = new Promise((resolve, reject) => {
            axios.get(Constants.BASE_URL + 'auth/token').then((res) => {
                resolve(res.data);
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        return (
            <div style={{ width: "100%" }} className="capa_manager">
                <Spin spinning={this.state.onLoading} size="large" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }} tip="Loading...">
                    <ScrollToTop />
                    <MenuSider title="CAPA management">
                        <div style={{ marginTop: "12px" }}>
                            <div style={{ width: "95%", marginLeft: '2.5%', textAlign: "right" }}>
                                <MonthPicker style={{ width: "35%" }} defaultValue={moment()} onChange={this.onChangeMonth} disabledDate={this.disabledDate} />
                            </div>
                            <Table
                                dataSource={this.state.dataObservation}
                                rowKey={row => row.PkObTranID}
                                loading={this.state.tableLoading}
                                scroll={{ x: 500 }}
                                // style={{ width: '95%', marginLeft: '2.5%' }}
                                rowClassName={(data) => {
                                    if (data.PkObTranID == this.state.ObtranID)
                                        return 'row-selection'
                                    else
                                        return ''
                                }}
                            >
                                <Column
                                    title={<IntlMessages id='Capa.ObservationDate' />}
                                    key='Observation_Date'
                                    render={(data, row) => {
                                        return data.Observation_Date.slice(8, 10) + '-' + data.Observation_Date.slice(5, 7) + '-' + data.Observation_Date.slice(0, 4) + ' ' + data.Observation_Time
                                    }}
                                />
                                {/* <Column
                                    title={<IntlMessages id='Details' />}
                                    dataIndex='Safe_detail'
                                    key='Safe_detail'
                                /> */}
                                {/* <Column
                                    title={<IntlMessages id='Action.current_unsafe' />}
                                    dataIndex='Unsafe_detail_corrective_action'
                                    key='Unsafe_detail_corrective_action'
                                /> */}
                                <Column
                                    title={<IntlMessages id='Action.next_action' />}
                                    dataIndex='Unsafe_detail_next_action'
                                    key='Unsafe_detail_next_action'
                                />
                                <Column
                                    title={<IntlMessages id='CreatedBy' />}
                                    key='CreatedBy'
                                    dataIndex={this.state.isEng ? 'CreatedByEN' : 'CreatedByTH'}
                                    align='center'
                                />
                                <Column
                                    title={<IntlMessages id='Status' />}
                                    dataIndex='status'
                                    align='center'
                                    render={(data, row) => {
                                        let status = !isNaN(row.CurrentStatus) ? row.CurrentStatus : 0
                                        return (
                                            <span>
                                                <Tag color={GetStatusColor(status)} key={status}>
                                                    {Object.keys(Status).find(key => Status[key] === status)}
                                                </Tag>
                                            </span>
                                        )
                                    }}
                                />
                                <Column
                                    title=''
                                    key=''
                                    width={100}
                                    align='center'
                                    fixed='right'
                                    render={(data, row) => (
                                        <div>
                                            {/* {
                                                row.Status === 0 ? (
                                                    <>
                                                        <Tooltip title="Take action">
                                                            <a href="javascript:;" onClick={() => this.handleClickTakeAction(row)}>
                                                                <Icon type={"carry-out"} style={{ fontSize: "17px" }} />
                                                            </a>
                                                        </Tooltip>
                                                        <Divider type="vertical" />
                                                    </>
                                                ) : null
                                            } */}

                                            <Tooltip title="View">
                                                <a href="javascript:;" onClick={() => this.handleClickView(row)}>
                                                    <Icon type={"search"} style={{ fontSize: "17px" }} />
                                                </a>
                                            </Tooltip>
                                        </div>
                                    )}
                                />
                            </Table>
                        </div>
                        <Modal
                            visible={this.state.visible}
                            title={null}
                            //onOk={this.handleOk}
                            //onCancel={this.handleCancel}
                            className='capa'
                            closable={false}
                            footer={[
                                <Button
                                    key="submit"
                                    type="primary"
                                    loading={this.state.approveLoading}
                                    onClick={() => this.handleAction(Status.Approved)}
                                    icon="check"
                                    disabled={this.state.isButtonLoading && !this.state.approveLoading}
                                >Approve</Button>,
                                <Button
                                    key="return"
                                    className='btn-warning'
                                    type="primary"
                                    loading={this.state.returnLoading}
                                    onClick={() => this.handleAction(Status.Returned)}
                                    icon="reload"
                                    disabled={this.state.isButtonLoading && !this.state.returnLoading}
                                >Return</Button>,
                                <Button
                                    key="reject"
                                    type="danger"
                                    loading={this.state.rejectLoading}
                                    onClick={() => this.handleAction(Status.Rejected)}
                                    icon="close"
                                    disabled={this.state.isButtonLoading && !this.state.rejectLoading}
                                >Reject</Button>,
                                <Button
                                    key="cancel"
                                    onClick={this.handleCancel}
                                >Cancel</Button>
                            ]}
                        >
                            <span className="ant-modal-confirm-title"><Icon className='ant-modal-confirm-warning' type="question-circle" />You would like to choose which item?</span>
                            <p className="ant-modal-confirm-content">Choosing an item will make the job continue.</p>
                        </Modal>
                    </MenuSider>
                </Spin>
            </div>
        )
    }
}